// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/gps-navigation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/gps-navigation/gps-navigation.js';

mount([g0]);
